<template>
	<div class="christmas-offer-program-benefits">
		<div v-for="(benefit, i) in benefits" :key="i" class="christmas-offer-program-benefits__item benefit-item">
			<div class="benefit-item__bullet"></div>
			<div class="benefit-item__text" v-html="benefit"></div>
		</div>
	</div>
</template>

<style lang="scss" scoped>
.christmas-offer-program-benefits {
	background: #f5f6f8;
	border-radius: 8px;
	padding: 1.5rem 2rem;

	&__item {
		&:not(:last-of-type) {
			margin-bottom: 1rem;
		}
	}

	.benefit-item {
		display: flex;
		align-items: center;

		&__bullet {
			min-width: 7px;
			height: 7px;
			border-radius: 50%;
			background: #7d8bf7;
			margin-right: 1rem;
		}

		&__text {
			font-size: 1rem;
			line-height: 1.3;
			letter-spacing: 0.5px;
			color: #323653;
		}
	}
}
</style>

<script>
import { computed } from '@vue/runtime-core'
import { useI18n } from 'vue-i18n'

export default {
	name: 'ChristmasOfferProgramBenefit',
	setup() {
		const { t } = useI18n()

		return {
			benefits: computed(() => [
				t('offers.christmas.pre.benefits.results'),
				t('offers.christmas.pre.benefits.habits'),
				t('offers.christmas.pre.benefits.foods_you_love')
			])
		}
	}
}
</script>
